import { Component } from '@angular/core';

import {groupModel } from "../../../model/groupModel";
import {person, personModel } from "../../../model/personModel";


@Component({
    selector: 'join-group',
    templateUrl: 'joinGroupPage.html'
})
export class joinGroupPage {
    constructor(
        public groupList: groupModel,
        public personProfile: personModel   
    ) {

    }
    join() {
        var groupJoin: Array<string> = new Array<string>();
        this.groupList.groups.forEach(
            function (item, index, group) {    
                if (item.checkedState)            
                    groupJoin.push(item.$key);
            }
        );
        this.personProfile.me.members=groupJoin;
        this.personProfile.update();
        console.log(this.personProfile.me);
    }

}





// WEBPACK FOOTER //
// ./src/pages/groups/joinGroup/joinGroupPage.ts